import {usePlantConfig} from '@domain/shifthandover'
import {DataContentWrapper} from '@hconnect/common/containers'
import {EventInfo} from '@widgets/shift-event-details'
import {useTranslation} from 'react-i18next'

import {ShiftTaskDetails, TaskDetailsCard} from '../../components'
import {FEATURE_NAMESPACE} from '../../consts'
import {useShiftTask} from '../../hooks'
import {mapEventInfoItem} from '../../mappers'
import {HProduceTaskIdentifiers, HProduceTask} from '../../types'
import {TaskChecklistsContainer} from '../TaskChecklistsContainer'

import {ShiftTaskAttachmentsContainer} from './ShiftTaskAttachmentsContainer'
import {ShiftTaskCommentsContainer} from './ShiftTaskCommentsContainer'

type Props = {
  task: HProduceTaskIdentifiers
  onClose: (original?: HProduceTask, editVersion?: HProduceTask) => void
  timezone: string
}

export const ShiftTaskDetailsContainer = ({task, timezone, onClose}: Props) => {
  const {t, i18n} = useTranslation(FEATURE_NAMESPACE)
  const {data, isLoading, isError, refetch, isRefetching} = useShiftTask(task)
  const {data: plantConfig} = usePlantConfig({plantId: task.plantId, language: i18n.language})

  return (
    <DataContentWrapper
      data={data}
      showLoader={isLoading}
      isError={isError}
      retryFunction={refetch}
      isRefetching={isRefetching}
      noDataSettings={{
        noDataMessage: t('task.message.taskNotFound'),
        onActionClick: () => onClose()
      }}
    >
      {data && (
        <TaskDetailsCard
          item={{...task, title: data.title, created: data.created} as HProduceTask}
          timezone={timezone}
          onClose={onClose}
          metaAnnotationSlot={
            <>
              {plantConfig && (
                <EventInfo
                  item={mapEventInfoItem(data)}
                  plantId={task.plantId}
                  workOrderTarget={plantConfig.workOrderTarget}
                />
              )}
            </>
          }
        >
          <ShiftTaskDetails shiftTask={data} plantId={task.plantId} />

          <TaskChecklistsContainer task={task} />
          <ShiftTaskAttachmentsContainer attachments={data.attachments} plantId={task.plantId} />
          <ShiftTaskCommentsContainer
            eventId={task.externalId}
            plantId={task.plantId}
            timezone={timezone}
          />
        </TaskDetailsCard>
      )}
    </DataContentWrapper>
  )
}
